<template>
  <v-card class="mb-10" max-width="850" flat>
    <v-card-title :style="partnerColor.gradientStyle" class="title pt-4" v-if="!hideTitle">
      <span :style="`color:white`">{{ $t("components.thg.ThgCreateOverviewCard.title") }}</span>
      <v-spacer />
    </v-card-title>
    <div v-if="!isAuthenticated">
      <v-list two-line>
        <v-list-item v-if="isCompany">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ showValueOrDefault(company, "components.thg.ThgCreateOverviewCard.company") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="!isResubmitTaxnumber">
              {{ showValueOrDefault(taxNumber, "components.thg.ThgCreateOverviewCard.taxNumber") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
              {{ $t("components.thg.ThgCreateOverviewCard.isResubmitTaxnumber") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="!taxNumber">
              {{ $t("components.thg.ThgCreateOverviewCard.hintTaxnumber2") }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!hideEdit">
            <v-btn icon>
              <v-icon @click="goToContactData" color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-email-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ showValueOrDefault(email, "components.thg.ThgCreateOverviewCard.mail") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ showValueOrDefault(name, "components.thg.ThgCreateOverviewCard.name") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ phone }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!hideEdit">
            <v-btn icon>
              <v-icon @click="goToContactData" color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-map-marker-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="!isResubmitAddress">
            <v-list-item-subtitle>
              {{ showValueOrDefault(street, "components.thg.ThgCreateOverviewCard.street") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ showValueOrDefault(address, "components.thg.ThgCreateOverviewCard.address") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ $t("components.thg.ThgCreateOverviewCard.hintAddress1") }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title>
              {{ $t("components.thg.ThgCreateOverviewCard.isResubmitAddress") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t("components.thg.ThgCreateOverviewCard.hintAddress2") }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!hideEdit">
            <v-btn icon>
              <v-icon @click="goToContactData" color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <div v-if="!showCustomerAccount">
          <v-list-item v-if="!isResubmitBankingInformation">
            <v-list-item-icon>
              <v-icon>mdi-credit-card-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ showValueOrDefault(banking.iban, "components.thg.ThgCreateOverviewCard.iban") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ showValueOrDefault(banking.bank, "components.thg.ThgCreateOverviewCard.bankname") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ showValueOrDefault(banking.name, "components.thg.ThgCreateOverviewCard.accountOwner") }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="!hideEdit">
              <v-btn icon>
                <v-icon @click="goToContactData" color="grey lighten-1">mdi-pencil</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-else>
            <v-list-item-icon>
              <v-icon>mdi-credit-card-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("components.thg.ThgCreateOverviewCard.resubmitBank") }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("components.thg.ThgCreateOverviewCard.hintResubmitBank") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <v-divider />
    </div>
    <div>
      <v-list two-line>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-counter</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ showValueOrDefault(numberplate, "components.thg.ThgCreateOverviewCard.numberplate") }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!hideEdit">
            <v-btn icon>
              <v-icon @click="goToContactData" color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="showYears">
          <v-list-item-icon>
            <v-icon>mdi-calendar-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ $t("components.thg.ThgCreateOverviewCard.years") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip v-for="(year, i) in years" :key="i" small class="mx-2">{{ year }}</v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!hideEdit">
            <v-btn icon @click="goToYearSelection">
              <v-icon color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-car-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ $t("components.thg.ThgCreateOverviewCard.registration") }}
              <v-icon v-if="isRegistrationFront" small>mdi-check</v-icon
              ><v-icon v-else color="red" small>mdi-close</v-icon>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="isRegistrationFront">
              {{ $t("components.thg.ThgCreateOverviewCard.registrationHint") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else>
              {{ $t("components.thg.ThgCreateOverviewCard.registrationHint2") }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!hideEdit">
            <v-btn icon @click="goToRegistration">
              <v-icon color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-row class="ml-14">
        <image-dialog v-if="isRegistrationFront" :src="getRegistrationImageFront" title="Vorderseite" />
      </v-row>
      <v-list two-line>
        <v-list-item v-if="!showCustomerAccount">
          <v-list-item-icon>
            <v-icon>mdi-chart-donut</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{
                $t("components.thg.ThgCreateOverviewCard.payoutSubtitle1", {
                  payout: payout
                })
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle style="color: #f44336 !important" v-if="showImpact">
              {{
                $t("components.thg.ThgCreateOverviewCard.impactSubtitle", {
                  impact: impact,
                  impactType: $t(impactType)
                })
              }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="!hideEdit">
            <v-btn icon @click="goToImpactSelector">
              <v-icon color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="showCustomerAccount">
          <v-list-item-icon>
            <v-icon>mdi-chart-donut</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle> Kundenkonto</v-list-item-subtitle>
            <v-list-item-subtitle v-if="!showImpact">
              {{ $t("components.thg.ThgCreateOverviewCard.customerAccount") }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="!hideEdit">
            <v-btn icon @click="goToImpactSelector">
              <v-icon color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-text class="mt-n4" v-if="showImpact">
        {{
          $t("components.thg.ThgCreateOverviewCard.hint", {
            impactType: $t(impactType),
            impact: impact,
            payOutRelative: payout
          })
        }}
      </v-card-text>
      <v-card-text v-if="isShowingPriceInformationForNextYear">
        {{ $t("components.thg.ThgCreateOverviewCard.hintPriceNextYear") }}
      </v-card-text>
      <v-card-text>
        {{ $t("components.thg.ThgCreateOverviewCard.hintUba") }}
      </v-card-text>
      <v-divider />
    </div>
  </v-card>
</template>

<script lang="ts">
import { IBankingDto } from "@/store/interface/thg/banking.interface";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Prop } from "vue-property-decorator";
import { ReportModule } from "@/store/modules/report.store";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { PartnerColor } from "@/lib/partnerColor";
import ImageDialog from "@/components/utility/ImageDialog.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import ThgContactScreensMixin from "./mixins/ThgContactScreensMixin.vue";
import { mixins } from "vue-class-component";
import ThgRegistrationScreensMixin from "./mixins/ThgRegistrationScreensMixin.vue";
import ThgImpactSelectorScreensMixin from "./mixins/ThgImpactSelectorScreensMixin.vue";

@Component({
  components: {
    ImageDialog
  }
})
export default class ThgCreateOverviewCard extends mixins(
  ThgContactScreensMixin,
  ThgRegistrationScreensMixin,
  ThgImpactSelectorScreensMixin
) {
  @Prop({ default: false })
  hideTitle?: boolean;

  @Prop({ default: false })
  hideEdit?: boolean;

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  partnerColor = new PartnerColor();

  get numberplate(): string {
    return ThgCreateModule.numberplate;
  }

  get banking(): IBankingDto {
    return ThgCreateModule.banking;
  }

  get name(): string {
    return ThgCreateModule.user.firstName + " " + ThgCreateModule.user.lastName;
  }

  get email(): string {
    return ThgCreateModule.contact.email;
  }

  get years(): number[] {
    return ThgCreateModule.years;
  }

  get isCompany(): boolean {
    return ThgCreateModule.isCompany;
  }

  get company(): string {
    return ThgCreateModule.company;
  }

  get taxNumber(): string {
    return ThgCreateModule.taxnumber;
  }

  get showYears(): number {
    return ThgCreateModule.years.length;
  }

  get isShowingPriceInformationForNextYear() {
    return ThgCreateModule.years.includes(2024);
  }

  get calenderYearsText(): string {
    if (this.showYears) {
      return "je Kalenderjahr";
    }
    return "";
  }

  get payout(): string {
    return 100 - ThgCreateModule.impactFactor + " %";
  }

  get showCustomerAccount(): boolean {
    return ThgCreateModule.impactType === ImpactTypeEnum.customerAccount;
  }

  get showImpact(): number {
    if (ThgCreateModule.impactType === ImpactTypeEnum.customerAccount) {
      return 0;
    }
    return ThgCreateModule.impactFactor;
  }

  showValueOrDefault(value: string, title: string) {
    if (!value.replace(" ", "")) {
      return this.$t("components.thg.ThgCreateOverviewCard.defaultValue", { title: this.$t(title) });
    }

    return value;
  }

  goToImpactSelector() {
    const screenName = this.impactSelectorScreens.find((screen) => ReportModule.screenOder.includes(screen));

    if (screenName) {
      this.goToScreen(screenName);
    } else {
      this.$toast.error(this.$t("components.thg.ThgCreateOverviewCard.errors.impactSelector"));
      this.$log.error(this.$t("components.thg.ThgCreateOverviewCard.errors.impactSelector"));
    }
  }

  goToContactData() {
    const screenName = this.contactScreens.find((screen) => ReportModule.screenOder.includes(screen));

    if (screenName) {
      this.goToScreen(screenName);
    } else {
      this.$toast.error(this.$t("components.thg.ThgCreateOverviewCard.errors.thgcontact"));
      this.$log.error(this.$t("components.thg.ThgCreateOverviewCard.errors.thgcontact"));
    }
  }

  goToRegistration() {
    const screenName = this.registrationScreens.find((screen) => ReportModule.screenOder.includes(screen));

    if (screenName) {
      this.goToScreen(screenName);
    } else {
      this.$toast.error(this.$t("components.thg.ThgCreateOverviewCard.errors.registration"));
      this.$log.error(this.$t("components.thg.ThgCreateOverviewCard.errors.registration"));
    }
  }

  goToYearSelection() {
    this.goToScreen(ReportScreenEnum.thgYearSelection);
  }

  goToScreen(screenName: ReportScreenEnum) {
    ReportModule.setStep(screenName);
    this.$router.push({ name: screenName });
  }

  get impact(): string {
    return ThgCreateModule.impactFactor + " %";
  }

  get impactType(): string {
    return ThgCreateModule.impactTypeItem.title;
  }

  get phone(): string {
    return ThgCreateModule.contact.phone;
  }

  get isResubmitAddress(): boolean {
    return ThgCreateModule.isResubmitAddress;
  }

  get isResubmitTaxnumber(): boolean {
    return ThgCreateModule.isResubmitTaxnumber;
  }

  get isResubmitBankingInformation(): boolean {
    return ThgCreateModule.isResubmitBankingInformation;
  }

  get street(): string {
    return ThgCreateModule.address.street;
  }

  get address(): string {
    return ThgCreateModule.address.zip + " " + ThgCreateModule.address.city;
  }

  get isRegistrationFront(): number {
    return ThgCreateModule.registrationImageFront.length;
  }

  get isRegistrationBack(): number {
    return ThgCreateModule.registrationImageBack.length;
  }

  fileToUrl(imageUploaded: IImageUploaded) {
    if (!imageUploaded || !imageUploaded.file) {
      return "";
    }

    let url = "";
    try {
      url = URL.createObjectURL(imageUploaded.file);
    } catch (error) {
      this.$log.error(error);
    }

    return url;
  }

  get getRegistrationImageFront(): string {
    if (ThgCreateModule.registrationImageFront.length === 0) {
      return "";
    }
    return this.fileToUrl(ThgCreateModule.registrationImageFront[0]);
  }

  get getRegistrationImageBack(): string {
    if (ThgCreateModule.registrationImageBack.length === 0) {
      return "";
    }
    return this.fileToUrl(ThgCreateModule.registrationImageBack[0]);
  }
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
